import { getActionTypeFromInstance } from '@ngxs/store';
import { LogoutSucceeded } from '../../../shared/auth.model';

export function logoutPlugin(state, action, next) {
  if (getActionTypeFromInstance(action) === LogoutSucceeded.type)
    state = (({ app }) => ({ app }))(state);
  return next(state, action);
}
